import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a7a2c718&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a2c718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7a2c718')) {
      api.createRecord('a7a2c718', component.options)
    } else {
      api.reload('a7a2c718', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a7a2c718&scoped=true&", function () {
      api.rerender('a7a2c718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zqB9IsqZjVVX/JS/comp/Accordion.vue"
export default component.exports